import { Modal } from '@monash/portal-react';
import { SUBMIT_TYPES } from '../constants';
import BulkPublishModalContents from './bulk-publish-modal-contents/BulkPublishModalContents';
import BulkScheduleModalContents from './bulk-schedule-modal-contents/BulkScheduleModalContents';
import BulkDeleteModalContents from './bulk-delete-modal-contents/BulkDeleteModalContents';
import BulkArchiveModalContents from './bulk-archive-modal-contents/BulkArchiveModalContents';
import BulkDeleteArchivedModalContents from './bulk-delete-archived-modal-contents/BulkDeleteArchivedModalContents';

// Map to determine which component to render
const BULK_ACTIONS_MODAL_CONTENTS = {
  [SUBMIT_TYPES.PUBLISH]: BulkPublishModalContents,
  [SUBMIT_TYPES.SCHEDULE]: BulkScheduleModalContents,
  [SUBMIT_TYPES.DELETE]: BulkDeleteModalContents,
  [SUBMIT_TYPES.ARCHIVE]: BulkArchiveModalContents,
  [SUBMIT_TYPES.DELETE_ARCHIVED]: BulkDeleteArchivedModalContents,
};

const BulkActionsModal = ({
  action,
  selectedLinks,
  addLink,
  updateLink,
  deleteLink,
  updateChecked,
  ...modalProps
}) => {
  const ModalContents = BULK_ACTIONS_MODAL_CONTENTS[action];

  return (
    <Modal {...modalProps}>
      {ModalContents && (
        <ModalContents
          onClose={modalProps.onClose}
          links={selectedLinks}
          addLink={addLink}
          updateLink={updateLink}
          deleteLink={deleteLink}
          updateChecked={updateChecked}
        />
      )}
    </Modal>
  );
};

export default BulkActionsModal;
